import "./Projects.css";

import Project, { ProjectProps } from "../../atoms/project/Project";


const projects: Array<ProjectProps> = [
	{
		title: "Trading Bot",
		description: "This bot executes trades on the Binance ecossistem and operates across a diverse range of cryptocurrencies, responding to signals from a custom TradingView strategy via webhook. It offers flexibility in trading strategies by allowing users to adjust leverage and engage in margin trading. Additionally, it features a user-friendly interface that provides a comprehensive view of past and active trades, as well as the current account balance.",
		img: "images/projects/trading-bot.png"
	},
	{
		title: "Rocket League Trading",
		description: "A trading platform for Rocket League items where the inventory can be managed, listing items up for sell alongside a wish list of desired purchases. The system is designed to scan the market (based on Rocket League Garage) for the best deals, automatically notifying the user for a potential good deal. It posts offers based on the latest market supply and demand, ensuring the trades are competitive. The platform also refreshes listings continuously, so the top deals are always recured and the sales are maximized. On top of it, the interface provides market information about any item in the game.",
		img: "images/projects/rocket-league-trading.png"
	},
	{
		title: "OGame Manager",
		description: "A strategic automation tool for OGame. It's crafted to handle various in-game tasks efficiently: from logging into the account to managing activities across all planets. The tool smartly prioritizes upgrades based on profitability, scouts for potential targets to attack, and implements protective measures when the empire is threatened. Additionally, it provides a streamlined overview of the resources, keeping the player well-informed and ready to make strategic decisions.",
		img: "images/projects/ogame-manager.png"
	},
	{
		title: "Replayer",
		description: "A versatile tool for automating and replicating user interactions. It's designed to record mouse movements, clicks, and keystrokes, then replay them exactly as they happened. Some tweaks to the records can be made, with options to adjust the playback speed, scale, and position offsets to fit different window sizes. Along with that, custom hotkeys to start, stop, and manage recordings quickly can be setup.",
		img: "images/projects/replayer.png"
	},
	{
		title: "Telegram Signal Analyzer",
		description: "This telegram bot captures messages related to trading signals from multiple channels and conducts a thorough analysis of past signals in the context of market conditions at the time they were published. The tool provides valuable insights into the performance of these signals, including metrics such as accuracy, profitability, maximum drawdown, and risk.",
		img: "images/projects/telegram-signal-analyzer.png"
	},
	{
		title: "Tower Defense",
		description: "This game is a Mouse-Driven Tower Defense and is still currently in development. Players can create custom maps or explore auto-generated maps filled with diverse terrains and enemies. The twist lies in tower placement: instead of the usual fixed positions, mouse positioning defines the firing origin. With a variety of enemy types, each possessing unique attributes, the player must strategically choose from multiple firing options to defend against waves of foes.",
		img: "images/projects/tower-defense.png"
	}
];


function Projects() {
	return (
		<div className="projects">
			<div className="projects__title">Projects</div>
			<div className="projects__list">
				{projects.map((project) => (
					<Project title={project.title} description={project.description} img={project.img} key={project.title} />
				))}
			</div>
		</div>
	);
}

export default Projects;
